<template>
  <div>
    <v-autocomplete
      v-model="localValue"
      :items="elementos"
      :item-text="itemText"
      :item-value="itemValue"
      outlined
      :label="label"
      :loading="loadingElemento"
      :disabled="loadingElemento || disabled"
      @change="updateValue"
      dense
      hide-details
      :filter="filterAutocomplete"
    >
      <template v-slot:input="slotProps">
        <input
          v-bind="slotProps.attrs"
          :value="slotProps.attrs.value"
          @input="slotProps.listeners.input"
          @blur="slotProps.listeners.blur"
          :name="'fake-name-' + _uid"
          autocomplete="new-password"
          autocapitalize="off"
          spellcheck="false"
        />
      </template>
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title>{{ data.item.nombre }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ data.item.descripcion }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>

  </div>
</template>

<script>
import axios from "axios"

export default {
  name: "VAutocompleteDiscapacidad",
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: ""
    },
    itemValue: {
      type: String,
      default: ""
    },
    itemText: {
      type: String,
      default: "nombre"
    },
    urlGet: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    }
  },
  mounted(){
    this.getElementos();
  },
  data: () => ({
    localValue: null,
    elementos: [],
    loadingElemento: false,
  }),
  methods: {
    getElementos(){
      this.loadingElemento = true;
      axios
      .get(this.urlGet)
      .then(response => {
        this.elementos = response.data;
      })
      .catch(error => [
        console.log(error)
      ])
      .finally(() => {
        this.loadingElemento = false;
      })
    },
    updateValue(){
      this.$emit('input', this.localValue);
    },
    normalize(str = '') {
      return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    },
    filterAutocomplete(item, queryText, itemText) {
      const text  = this.normalize(itemText);
      const query = this.normalize(queryText);
      return text.startsWith(query);
    },
  }
}
</script>
